import React, {
  createContext,
  useContext,
  useCallback,
  useState,
  useEffect,
} from "react";
import AsyncStorage    from "@react-native-async-storage/async-storage";
import Engage          from "../services/engage";
import { DEVICE_UUID } from "../constants/app";

import {
  persistEngageUserAsync,
  loadEngageUserAsync,
} from "../helpers/cache.native";

const UserContext = createContext({});

export function UserProvider({ value, children, onReady }) {

  const [user, setUser] = useState(value);
  const [loading, setLoading] = useState(false);

  const loadUser = useCallback(async () => {
    let userObj = await loadEngageUserAsync();
    userObj && setUser({ ...userObj });
    return userObj;
  }, [user, setUser]);

  const updateUser = useCallback(
    (data) => {
      if (!data) return false;
      const userData = { ...user, ...data };
      setUser(userData);
      persistEngageUserAsync(userData);
    },
    [user, setUser]
  );

  const getUser = useCallback(async () => {
    setLoading(true);
    if (!loading && user?.id) {
      const res = await Engage.getUser();
      if (res.error) {
        console.error(res.error);
        await logout();
      } else {
        setUser(res.response);
        persistEngageUserAsync(res.response);
      }
    }
    setLoading(false);
  }, [user, loading, logout, setUser, setLoading]);

  const logout = useCallback(async () => {
    await Engage.removeDevice(DEVICE_UUID);
    await AsyncStorage.clear();
    await Engage.logout();
    setUser(null);
  }, [DEVICE_UUID,setUser]);

  useEffect(() => {
    loadUser();
  }, [false]);

  useEffect(() => {
    (async () => {
      if (user?.id) {
        await getUser();
      }
      onReady && onReady(true)
    })();
  }, [user?.id]);

  return (
    <UserContext.Provider
      value={{
        loggedIn: !!user?.id,
        logout,
        user,
        getUser,
        updateUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export default UserContext;
